import type { SWITCH_STATUS } from '@umu/umu-types';

/**
 * 认证证书绑定类型
 */
export enum RecognizeObjectType {
    COURSE = 1,
    PROGRAM = 2,
}
/**
 * 通用配置操作响应接口
 */
export interface ICommonResponse {
    isSuccess: boolean;
    message?: string;
}

/**
 * 领取证书请求参数
 */
export interface IReceiveCertificateParams {
    obj_id: string;
    obj_type: RecognizeObjectType;
}
export interface IGetCertificateDetailParams {
    id?: string;
    obj_id?: string;
    obj_type?: RecognizeObjectType;
    caet_number?: string;
}
export interface IPageParams {
    page: number;
    size: number;
}

export enum CertificatePermission {
    PUBLIC = 1,
    PRIVATE = 2,
}

export enum CertificateReceiveStatus {
    NOT_RECEIVED = 1,
    RECEIVED = 2,
}
export interface ICaetSwitchInfo {
    switch: SWITCH_STATUS; // 企业开关
    is_caet_obj: SWITCH_STATUS; // 是否是 Ai 力资源
}
/**
 * 证书数据结构
 */
export interface IAiCertificateItem {
    id: string; // 证书ID
    umu_id: string; // UMU ID
    user_name: string; // 用户姓名
    receive_ts: string; // 领取时间
    switch: SWITCH_STATUS; // 策略开关
    is_exist: SWITCH_STATUS; // 是否存在
    is_bind: SWITCH_STATUS; // 是否绑定
    obj_type: RecognizeObjectType; // 课程类型（1=课程）
    obj_info: {
        name: string; // 名称
        img: string; // 封面
        m_name: string; // 名称
        m_img: string; // 封面
        url: string; // 链接
        content_number: string; // 小节个数
        duration: string; // 学习时间
        purchase_link: string; // 购买链接
    };
    obj_id: string; // 学习对象 ID
    names: Array<{
        // 认证名号
        img_url: string;
        name: string;
    }>;
    caet_number: string; // 证书编号
    completion_ts: string; // 完成时间
    certificate_url: string; // 证书URL
    duration: string; // 学习时间
    permission: CertificatePermission; // 权限（1：公开；2：私密）
    receive_status: CertificateReceiveStatus; // 领取状态（0：未领取，1：已领取）
}
export interface ICaetResourceConfig {
    is_show: SWITCH_STATUS;
    is_bind: SWITCH_STATUS;
    email: string;
    receive_status: CertificateReceiveStatus;
}
/**
 * 推荐课程数据结构
 */
export interface IAiRecommendedCoursePurchaseMethod {
    method: number;
    amount: string;
    price: string;
    discount: string;
}

export interface IAiRecommendedCourseLabel {
    id: string;
    label_type: string;
    label_name: string;
    rank: string;
    create_ts: string;
    update_ts: string;
}

export interface IAiRecommendedCourseResourceInfo {
    id: string; // 课程ID
    encrypted_id: string; // 加密ID
    obj_title: string; // 课程标题
    owner_name: string; // 创建者名称
    owner_desc: string; // 创建者描述
    category_id: string; // 分类ID
    share_url: string; // 分享链接
    cover_url: string; // 封面图片URL
    m_obj_title: string | null; // 移动端标题
    m_owner_name: string | null; // 移动端创建者名称
    m_owner_desc: string | null; // 移动端创建者描述
    m_cover_url: string; // 移动端封面图片URL
    session_num: string; // 课时数
    student_num: number; // 学员数
    duration: string; // 时长（秒，来自样例是字符串）
    quality_level: string; // 质量等级
    released_date: string; // 发布日期
    recommend_date: string; // 推荐日期
    price: string; // 价格
    purchase_method_list: IAiRecommendedCoursePurchaseMethod[]; // 购买方式列表
    label_list: IAiRecommendedCourseLabel[]; // 标签列表
    product_label_name: string; // 产品标签名称
    is_top: string; // 是否置顶
    is_recommend: string; // 是否推荐
    is_show_buy_btn: string; // 是否显示购买按钮
    created_at: string; // 创建时间
    updated_at: string; // 更新时间
    is_fake: string; // 是否虚假
    is_released: string; // 是否已发布
    code: string; // 课程代码
    course_type: string; // 课程类型
}

export interface IAiRecommendedCourseItem {
    id: string; // 课程ID
    obj_id: string; // 对应 resource_info.id
    obj_type: string; // 对应资源类型
    resource_info: IAiRecommendedCourseResourceInfo; // 资源信息
}

/**
 * 设置证书信息请求参数
 */
export interface ISetCertificateSettingParams {
    user_name?: string;
    email?: string;
}

/**
 * 设置证书权限请求参数
 */
export interface ISetCertificatePermissionParams {
    id: string;
    permission: CertificatePermission;
}

/**
 * 获取证书设置信息响应数据
 */
export interface IGetCertificateSettingResponse extends ISetCertificateSettingParams {
    status: SWITCH_STATUS;
    next_editable_time: string;
}
